
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.188 5.733l-4.854 4.85L2.5 11.75m.583-2.917L4.25 10m6.417-6.125a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z","stroke":"#1C2F45","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    